module.exports = __webpack_public_path__ + "static/media/ht_earthing_pipe_plate_welded.af02d8ad.webp";